import {io} from "socket.io-client";
import {useEffect, useRef} from "react";

export function randomBytes(length) {
    //without using crypto.randomBytes

    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
        result += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return result;
}

class SocketUtils {

    static socket;
    static localId;
    static isHost;
    static queuedListeners = [];

    static async connect({deviceId, uid}) {
        if (this.socket) {
            if (this.socket.connected && this.socket.io.opts.query?.uid === uid && this.socket.io.opts.query?.deviceId === deviceId) {
                return;
            }
            this.socket.disconnect();
        }
        this.localId = randomBytes(16);
        this.socket = io("wss://torresowo.myftp.org:7777/towers-chatbot", {
            transports: ['websocket'],
            query: {
                deviceId,
                uid,
            }
        });

        // Register any queued listeners
        this.queuedListeners.forEach(({ event, callback }) => {
            this.socket.on(event, callback);
        });
    }

    static disconnect() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    static on(event, callback) {
        // Queue the listener
        this.queuedListeners.push({ event, callback });

        // If socket is initialized, register immediately
        if (this.socket) {
            this.socket.on(event, callback);
        }
    }

    static emit(event, data) {
        if (!this.socket) {
            return;
        }
        this.socket.emit(event, data);
    }

    static off(event, callback) {
        // Remove from queue
        this.queuedListeners = this.queuedListeners.filter(
            item => !(item.event === event && item.callback === callback)
        );

        // If socket is initialized, deregister immediately
        if (this.socket) {
            this.socket.off(event, callback);
        }
    }

    static removeListeners() {
        this.queuedListeners = [];
        if (this.socket) {
            this.socket.removeAllListeners();
        }
    }

}

export const useAddSocketEvents = ({connected, events}) => {
    const eventsRef = useRef(events);

    useEffect(() => {
        eventsRef.current = events;
    }, [events]);

    useEffect(() => {
        if (!connected) return;

        const listeners = {};
        if (events) {
            Object.keys(events).forEach(event => {
                const listener = (...args) => {
                    if (eventsRef.current && eventsRef.current[event]) {
                        eventsRef.current[event](...args);
                    }
                };
                listeners[event] = listener;
                SocketUtils.on(event, listener);
                console.log("Added socket event listener for event:", event);
            });
        }

        return () => {
            if (events) {
                Object.keys(events).forEach(event => {
                    SocketUtils.off(event, listeners[event]);
                });
            }
        };
    }, [connected]);
}

export const useSocketEvents = ({connected, events}) => {

    useAddSocketEvents({connected, events});

    useEffect(() => {
        if (!connected) return;

        const handleOnConnect = () => {
            console.log('connected');
        }

        const handleOnDisconnect = () => {
            console.log('disconnected');
        }

        SocketUtils.on('connect', handleOnConnect);

        SocketUtils.on('disconnect', handleOnDisconnect);

        return () => {
            SocketUtils.off('connect', handleOnConnect);
            SocketUtils.off('disconnect', handleOnDisconnect);
        }
    }, [connected]);
}

export default SocketUtils;
